import type { CityConfig } from "../city-template/types";

export const roswellNmConfig: CityConfig = {
  city: "Roswell",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "roswell-nm",
  route: "/cities/roswell-nm",
  title: "Emergency Passport Roswell, NM — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Roswell, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving NMMI students, Chaves County families, and southeastern New Mexico energy workers.",
  h1: "Emergency & Expedited Passport Services in Roswell, New Mexico",
  heroSubtitle: "NMMI cadet with an international exchange program starting next week? Permian Basin oil field professional with an overseas assignment? Chaves County rancher heading to an agricultural conference abroad? We help Roswell residents get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Roswell%20New%20Mexico%20downtown%20Main%20Street%20with%20historic%20buildings%20and%20classic%20neon%20signs%2C%20the%20International%20UFO%20Museum%20and%20Research%20Center%20storefront%2C%20New%20Mexico%20Military%20Institute%20campus%20with%20iconic%20Gothic%20architecture%2C%20the%20Pecos%20River%20valley%20with%20cottonwood%20trees%2C%20southeastern%20New%20Mexico%20high%20desert%20landscape%20with%20dramatic%20sky%2C%20warm%20sunset%20light%2C%20professional%20travel%20photography&width=1800&height=700&seq=roswell-nm-hero-2026&orientation=landscape",
  heroImageAlt: "Roswell New Mexico downtown Main Street with UFO Museum and NMMI campus",
  geoPosition: "33.3943;-104.5230",
  geoPlacename: "Roswell, New Mexico",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 200 miles south of Roswell. The nearest passport agency serving southeastern New Mexico.",
  },
  nearbyCitiesZips: [
    { name: "Roswell", zips: "88201–88203" },
    { name: "Artesia", zips: "88210–88211" },
    { name: "Dexter", zips: "88230" },
    { name: "Hagerman", zips: "88232" },
    { name: "Lake Arthur", zips: "88253" },
    { name: "Carlsbad", zips: "88220–88221" },
    { name: "Hobbs", zips: "88240–88242" },
    { name: "Ruidoso", zips: "88345" },
  ],
  benefits: [
    { icon: "ri-shield-line", title: "New Mexico Military Institute (NMMI)", desc: "NMMI is one of the nation's premier military preparatory schools and junior colleges. Cadets participate in international exchange programs, study abroad, and foreign language immersions that require fast passport processing on academic schedules." },
    { icon: "ri-oil-line", title: "Permian Basin Energy Hub", desc: "Roswell and Artesia are key energy production and service centers in the Permian Basin. Oil and gas professionals on international rotations, equipment training programs, and global conferences need reliable expedited passport services." },
    { icon: "ri-flight-takeoff-line", title: "Roswell Air Center (ROW)", desc: "ROW is a major regional airport with connections to Dallas/Fort Worth and Phoenix. American Eagle service connects southeastern New Mexico to international gateways. We coordinate passport timelines around ROW departure schedules." },
    { icon: "ri-landscape-line", title: "Chaves County Agricultural Economy", desc: "Roswell is the agricultural hub of the Pecos Valley — dairy, alfalfa, pecans, and chile farming. Ranchers and agricultural professionals travel internationally for trade shows, equipment purchases, and agricultural exchanges." },
    { icon: "ri-aliens-line", title: "UFO Tourism & International Visitors", desc: "Roswell's world-famous UFO incident draws international visitors year-round. Tourism and hospitality professionals, museum staff, and event coordinators regularly travel abroad for conferences, trade events, and cultural exchanges." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albuquerque, NM", route: "/cities/albuquerque" },
    { name: "Expedited passport in Carlsbad, NM", route: "/cities/carlsbad-nm" },
    { name: "Passport help in Hobbs, NM", route: "/cities/hobbs" },
    { name: "New Mexico passport services overview", route: "/states/new-mexico" },
  ],
  fpcOfficeAddress: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
  fpcOfficeNote: "Fast Passport Center serves Roswell via secure registered courier with direct access to the El Paso Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the 200-mile drive. Roswell residents can ship from any UPS Store, FedEx Office, or post office location across Chaves County.",
  fpcOfficeDistance: "Serving Roswell, Artesia, Dexter, Hagerman, Lake Arthur, and all Chaves County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Roswell and all of Chaves County. From historic Main Street to the NMMI campus, from the Roswell Air Center to the Pecos Valley agricultural communities — we serve the entire Roswell region. Our courier service eliminates the need to drive 3+ hours to El Paso.",
  nearbyCitiesIntro: "We serve Roswell and surrounding Chaves County communities including Artesia, Dexter, Hagerman, and Lake Arthur. We also serve the broader southeastern New Mexico region including Carlsbad, Hobbs, and Lovington.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Roswell simple — with the reliability NMMI cadets, Permian Basin energy workers, and Chaves County families need. Because we are a registered U.S. Department of State courier, we pass those savings directly to you.",
  mistakesIntro: "Roswell travelers face unique passport challenges — from NMMI academic calendar deadlines to Permian Basin rotation schedules. Here are the most common mistakes we see from this area.",
  testimonialsIntro: "Southeastern New Mexico travelers — from NMMI cadets to Permian Basin professionals to Chaves County ranch families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Roswell, NM? Here are the most common ones we hear from Chaves County travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before an NMMI exchange program, an emergency passport for an energy industry deployment, or a first-time passport for a Pecos Valley family vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://www.co.chaves.nm.us/",
  dmvLabel: "Chaves County — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "El Paso agency is 200 miles from Roswell", "3+ hour drive — requires full day off"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No El Paso trip needed", "Ideal for NMMI cadets and energy workers", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned international travel", "Document review included"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review", "Not suitable if travel within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "NMMI exchange program starting in 48 hours? Energy industry emergency deployment? Emergency processing as fast as 24 hours for Roswell travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Roswell residents renew fast — ideal for Permian Basin pros and Pecos Valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance step. We guide Roswell residents through every detail.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require Form DS-64. We guide you through everything so your trip stays on track.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minor child passport expedited service for southeastern New Mexico families traveling abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Roswell NM", description: "Urgent passport processing for Roswell New Mexico travelers." },
    { name: "Expedited Passport Renewal Roswell NM", description: "Fast passport renewal for Roswell and Chaves County residents." },
    { name: "First-Time Passport Roswell NM", description: "New passport application services for Roswell residents." },
    { name: "Child Passport Roswell NM", description: "Minor passport services for Roswell families." },
  ],
  testimonials: [
    {
      name: "Cadet James T.",
      location: "NMMI, Roswell",
      rating: 5,
      text: "Selected for an exchange program at a French military academy with 12 days notice. Needed my first adult passport. Fast Passport Center walked me through the Roswell Post Office acceptance and had my passport in 5 days. The NMMI command staff was impressed with how fast it came through.",
      service: "New Passport — Rush",
    },
    {
      name: "Diana L.",
      location: "Roswell",
      rating: 5,
      text: "Oil field services manager with a training deployment to Saudi Arabia. Two weeks notice and an expired passport. Fast Passport Center renewed in 4 days. Shipped from the UPS Store downtown. Absolutely essential for Permian Basin professionals.",
      service: "Expedited Renewal",
    },
    {
      name: "The Ramirez Family",
      location: "Artesia",
      rating: 5,
      text: "Family reunion in Mexico — realized 3 of 5 family members had expired passports. Fast Passport Center handled everything. All three arrived in 7 days. The bilingual support and clear instructions made it easy for our multi-generational family.",
      service: "Family Passport Services",
    },
    {
      name: "Bob M.",
      location: "Dexter",
      rating: 5,
      text: "Dairy farmer heading to an international agricultural equipment expo in the Netherlands. First passport ever. They guided me through every step from the Hagerman Post Office acceptance. Passport in 6 days. Incredible service for rural southeastern New Mexico.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "ros-1",
      name: "Roswell Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "415 N Pennsylvania Ave",
      city: "Roswell",
      state: "NM",
      zip: "88201",
      phone: "(575) 622-4952",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Roswell",
      website: "https://tools.usps.com/find-location.htm?location=1376547",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Roswell and Chaves County. Photo services available on-site. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "ros-2",
      name: "Chaves County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "1 St Mary's Place, Suite 110",
      city: "Roswell",
      state: "NM",
      zip: "88201",
      phone: "(575) 622-4131",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Roswell — Chaves County Administrative Center",
      website: "https://www.co.chaves.nm.us/",
      websiteLabel: "Chaves County Website",
      notes: "County clerk passport acceptance at the administrative center. Appointment recommended. Convenient downtown location.",
      icon: "ri-government-line",
    },
    {
      id: "ros-3",
      name: "Artesia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N 4th St",
      city: "Artesia",
      state: "NM",
      zip: "88210",
      phone: "(575) 746-3511",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "Artesia — about 40 miles south of Roswell",
      website: "https://tools.usps.com/find-location.htm?location=1376534",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for southern Chaves County and northern Eddy County residents. Limited hours.",
      icon: "ri-mail-line",
    },
    {
      id: "ros-4",
      name: "Carlsbad Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 W Stevens St",
      city: "Carlsbad",
      state: "NM",
      zip: "88220",
      phone: "(575) 885-3212",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Carlsbad — about 75 miles south of Roswell via US-285",
      website: "https://tools.usps.com/find-location.htm?location=1376541",
      websiteLabel: "USPS Location",
      notes: "Larger facility in Eddy County. Full photo services. Good alternative when Roswell facilities are booked.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — El Paso Passport Agency, 200 miles from Roswell", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 3+ hour drive to El Paso, TX", fpc: "Most Roswell travelers ship overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review to reduce delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Roswell", agency: "200 miles to El Paso — full day off work required", fpc: "Entirely remote — ship from Roswell, receive at your door" },
    { feature: "Cost vs Resellers", agency: "Government fees plus travel costs and lost work day", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "NMMI Academic Calendar Deadlines",
      description: "Cadets receiving exchange program acceptances often have extremely tight deadlines. International programs may require passport copies months before departure. Start your passport application as soon as you apply for any international program.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Permian Basin Rotation Schedule Crunch",
      description: "Energy workers on rotational schedules (7/7, 14/14) have limited windows for passport tasks. Plan acceptance visits and document shipping during your days off in Roswell.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Roswell Air Center Connection Timing",
      description: "ROW flights to DFW and PHX are limited to a few daily departures. If your international connection requires an overnight layover, factor that into your passport timeline — you need the passport in hand before your first flight, not just your international leg.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Multi-State Documentation for Transplants",
      description: "Many Roswell residents relocated here for energy industry or NMMI positions. Birth certificates issued in other states may take longer to obtain certified copies. We help verify document requirements before you submit.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your departure — NMMI exchange, energy deployment, or family travel." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "Personalized document checklist — cadet, energy professional, or Chaves County family tailored." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Ship from the Roswell Post Office on Pennsylvania Avenue or any FedEx/UPS in Chaves County." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Documents submitted through reserved agency slots — no El Paso drive needed." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives", description: "Completed within your timeframe and shipped to your Roswell or Chaves County address." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Roswell?", a: "We offer Roswell-area clients expedited processing as fast as 24 hours. Standard expedited through our courier channel takes 5–10 business days. The nearest regional agency is El Paso (200 miles) — our remote service is the practical fast option." },
    { q: "Do I need to visit an office in Roswell?", a: "No office visit for most services. Complete forms online, visit a local acceptance facility (Roswell Post Office or Chaves County Clerk) if you are a first-time applicant, then ship documents overnight. Adult renewals typically skip the acceptance step." },
    { q: "Where can I get passport acceptance in Roswell?", a: "Roswell Main Post Office on Pennsylvania Avenue and the Chaves County Clerk at the administrative center. Alternatives in Artesia (40 miles) and Carlsbad (75 miles). All require appointments." },
    { q: "Can NMMI cadets get expedited passports for exchange programs?", a: "Yes. We regularly serve NMMI cadets with fast passport processing for international military exchange programs and study abroad. We understand the tight timelines and command requirements." },
    { q: "What airport do Roswell travelers use for international flights?", a: "Roswell Air Center (ROW) has daily American Eagle flights to DFW and PHX, both major international gateways. Some travelers also use El Paso International (ELP, 200 miles) or Albuquerque Sunport (ABQ, 200 miles)." },
    { q: "How do I get a passport photo in Roswell?", a: "Roswell Main Post Office offers on-site photo services. UPS Store on Main Street, Walgreens, and CVS also provide passport photos. 2x2 inches, white background, no glasses." },
  ],
  photoLocations: [
    { name: "Roswell Main Post Office Photos", address: "415 N Pennsylvania Ave, Roswell, NM 88201", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "UPS Store — Roswell", address: "1410 S Main St, Roswell, NM 88203", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Walgreens — Roswell", address: "3000 N Main St, Roswell, NM 88201", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "New Mexico MVD — Roswell",
      address: "200 E Wilshire Blvd, Roswell, NM 88201",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD. Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ROW",
      name: "Roswell Air Center",
      distance: "About 7 miles south of downtown Roswell",
      address: "1 Jerry Smith Cir, Roswell, NM 88203",
      note: "Daily American Eagle flights to Dallas/Fort Worth (DFW) and Phoenix (PHX). Both are major international gateways. The primary airport for southeastern New Mexico.",
      flightUrl: "https://www.roswell-nm.gov/240/Airport",
      flightLabel: "ROW Airport Website",
      featured: true,
    },
    {
      code: "ELP",
      name: "El Paso International Airport",
      distance: "About 200 miles south of Roswell (3 hours via US-285/I-10)",
      address: "6701 Convair Rd, El Paso, TX 79925",
      note: "Larger Texas airport with more flight options. Alternative for Roswell travelers heading to Mexico, Central America, or needing more connections.",
      flightUrl: "https://www.elpasointernationalairport.com/",
      flightLabel: "ELP Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified New Mexico birth certificates from the NM Department of Health.", url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Chaves County Clerk.", url: "https://www.co.chaves.nm.us/" },
  ],
};